import { apiAdn, getUIContext } from "./common";
import { AxiosPromise } from "axios";
import { Notification, NotificationGroup, UnreadCountByGroup } from "types/Notification";

export function getUnreadNotificationCountByGroup(): AxiosPromise<UnreadCountByGroup> {
  const context = getUIContext();
  return apiAdn.get(`/notifications/unread/count?${context}`);
}

export function getNotifications(
  group: NotificationGroup,
  first: number,
  size: number,
): AxiosPromise<Notification[]> {
  const context = getUIContext();
  return apiAdn.get(`/notifications?${context}&group=${group}&first=${first}&size=${size}`);
}

export function validateNotification(id: string): AxiosPromise<Notification> {
  const context = getUIContext();
  return apiAdn.post(`/notifications/${id}/validate?${context}`);
}

export function validateAllNotification(): AxiosPromise<Notification[]> {
  const context = getUIContext();
  return apiAdn.post(`/notifications/validate-all?${context}`);
}
